
export interface CustomFieldValue {
  text?: string;
  number?: number;
  boolean?: boolean;
  json?: object;
}

export enum CustomFieldType {
  TEXT = 'text',
  SELECT = 'select',
  BOOLEAN = 'boolean'
}

export enum CustomFieldEntityType {
  CONTACT = 'contact',
  COMPANY = 'company',
  CANDIDATE = 'candidate',
  JOB = 'job',
  DEAL = 'deal',
  PLACEMENT = 'placement'
}

export type UpdateCustomFieldValueDto = {
  fields: {
    config_id: string;
    value: CustomFieldValue;
  }[];
}

export type UpdateCustomFieldConfigDto = {
  configs: {
    id?: string;
    field_type: CustomFieldType;
    label: string;
    options?: string[];
    is_required?: boolean;
  }[];
}

export interface ICustomField {
  id: string;
  config: ICustomFieldConfig;
  value: CustomFieldValue;
}

export interface ICustomFieldConfig {
  id: string;
  field_type: CustomFieldType;
  label: string;
  options?: string[];
  is_required?: boolean;
  entity_type: CustomFieldEntityType;
  created_at: string;
  updated_at: string;
}